import React, { useEffect, useRef, useState } from 'react';
import { createBrandMark } from './brand-motion.js';
import './museum-motion.css';
import './motion-copy.css';

export default function BootSplash({ ready, reduced }) {
  const holder=useRef(null),started=useRef(performance.now());
  const [stage,setStage]=useState('loading');
  useEffect(()=>{
    const mark=createBrandMark('boot');holder.current?.append(mark.element);
    return ()=>mark.dispose();
  },[]);
  useEffect(()=>{
    if(!ready)return;
    if(reduced){setStage('done');return;}
    let end;
    const begin=setTimeout(()=>{
      setStage('leaving');end=setTimeout(()=>setStage('done'),300);
    },Math.max(0,540-(performance.now()-started.current)));
    return ()=>{clearTimeout(begin);clearTimeout(end);};
  },[ready,reduced]);
  if(stage==='done')return null;
  return <div className={`brand-boot boot-${stage}`} data-boot-stage={stage} aria-label="PARALYZE AREA loading" aria-busy={!ready}>
    <div className="boot-mark-holder" ref={holder}/><span className="boot-caption">PARALYZE AREA</span>
    <span className="sr-only" role="status">{ready?'展示を開きます':'展示を準備しています'}</span>
  </div>;
}
